module.exports = __webpack_public_path__ + "static/media/elegirSucursal__metrobus.dae23e5e.svg";